import * as React from 'react';

const rescheduleAppointmentContextDefaultValues = {
    config: {
        opco: '',
        googleMapsApiKey: '',
        storesUrl: '',
        bookAppointmentUrl: '',
        cancelAppointmentUrl: '',
        appointmentDisplayType: 'single',
        appointmentTypes: undefined,
        offerFallbackImageUrl: undefined
    },
    appointment: undefined,
    setAppointment: ()=>null
    ,
    store: undefined,
    setStore: ()=>null
    ,
    selectedTimeSlot: undefined,
    setSelectedTimeSlot: ()=>null
};
const RescheduleAppointmentContext = /*#__PURE__*/ React.createContext(rescheduleAppointmentContextDefaultValues);
const useRescheduleAppointmentContext = ()=>{
    const context = React.useContext(RescheduleAppointmentContext);
    if (context === rescheduleAppointmentContextDefaultValues) {
        throw new Error('No RescheduleAppointmentContext available. You might still need to wrap the application with the RescheduleAppointmentProvider component.');
    }
    return context;
};
RescheduleAppointmentContext.displayName = 'RescheduleAppointment';
RescheduleAppointmentContext.Consumer;

export { RescheduleAppointmentContext, rescheduleAppointmentContextDefaultValues, useRescheduleAppointmentContext };
//# sourceMappingURL=context.js.map
